import CompactSWIcon from "../../assets/product-list-assets/compact2.svg";
import type { ProductListGroup } from "../../types";

export const switchingCompact: ProductListGroup = {
  id: "switchingCompact",
  title: "productListGroup.switchingCompact.title",
  seriesLabel: "modelCompare.seriesLabel.switchingCompact",
  icon: {
    src: CompactSWIcon,
    width: 24,
    height: 24,
  },
};
